import { RefObject } from 'react'
import { makeAutoObservable } from 'mobx'
import { PopoverPosition } from '../../popover/PopoverSurface'
import { formatDuration } from './duration-utils'

interface GapDurationStoreProps {
   attributes: Record<string, string> | undefined
   updateMdastNode: (node: any) => void
   removeNode: () => void
   chipRef: RefObject<HTMLSpanElement>
}

export default class GapDurationStore {
   sp
   popover: PopoverPosition | null = null

   constructor(sp: GapDurationStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get label() {
      return formatDuration(this.sp.attributes?.value)
   }

   handleChipMouseDown = (event: React.MouseEvent) => {
      event.preventDefault()
      event.stopPropagation()
      const chipElement = this.sp.chipRef.current
      if (!chipElement) return
      const rect = chipElement.getBoundingClientRect()
      this.popover = { left: rect.left, top: rect.top, bottom: rect.bottom }
   }

   handlePicked = (minutes: number) => {
      this.sp.updateMdastNode({ attributes: { ...this.sp.attributes, value: String(minutes) } })
      this.popover = null
   }

   handleRemove = () => {
      this.popover = null
      this.sp.removeNode()
   }

   handleClose = () => {
      this.popover = null
   }
}
